import {Injectable} from "@angular/core";
import {throwError} from "rxjs";
import {LoaderService} from "./loader.service";
import {HttpErrorResponse, HttpStatusCode} from "@angular/common/http";
import {AuthenticationService, EXTERNAL_LOGIN_URL, LOGIN_URL} from "./authentication.service";
import {TOAST_STATE, ToastService} from "./toast.service";
import {TranslocoService} from "@ngneat/transloco";
import {WSPAY_PAYMENT_CANCEL, WSPAY_PAYMENT_ERROR, WSPAY_PAYMENT_SUCCESS} from '../app-routing.module';

@Injectable({ providedIn:'root' })
export class ErrorService {

  constructor(private loaderService: LoaderService, private authenticationService: AuthenticationService,
              private toastService: ToastService, private translocoService: TranslocoService) {
  }

  handleError(error: any) {
    /// check if we are trying to access wspay redirect uri while calling refresh token uri
    var isWsPaymentRoute: boolean = false;
    var path: string | undefined = document.location.href;
    if (path && (path.includes(WSPAY_PAYMENT_SUCCESS)
      || path.includes(WSPAY_PAYMENT_ERROR)
      || path.includes(WSPAY_PAYMENT_CANCEL))) {
      isWsPaymentRoute = true;
    }

    this.loaderService.dismissLoading();
    if (error instanceof HttpErrorResponse && error.status === HttpStatusCode.Unauthorized
      && !error.url?.includes(LOGIN_URL) && !error.url?.includes(EXTERNAL_LOGIN_URL)) {
      /// if we are trying to login on wspay uri then don't show message and don't redirect to landing with logout,
      // wspay uri are public but it is ok to try to auto login to allow loggeding user to stey login on wspay redirect
      if (isWsPaymentRoute) {
        this.authenticationService.logout(false);
      } else {
        this.toastService.showToast(TOAST_STATE.danger, this.translocoService.translate('app.common.session.timeout'));
        this.authenticationService.logout();
      }
    } else if (error instanceof HttpErrorResponse && error.status === HttpStatusCode.PayloadTooLarge) {
      this.toastService.showToast(TOAST_STATE.danger, this.translocoService.translate('app.common.server.payloadTooLarge'));
    } else if (error instanceof HttpErrorResponse && error.status !== HttpStatusCode.Unauthorized) {
      this.toastService.showToast(TOAST_STATE.danger, this.translocoService.translate('app.common.server.error'));
    } else if (error instanceof HttpErrorResponse && error.status === HttpStatusCode.Unauthorized
        && error.url?.includes(LOGIN_URL)) {
      this.toastService.showToast(TOAST_STATE.danger, this.translocoService.translate('app.common.login.error'));
    }
    return throwError(error);
  }
}
